import React, { Component, Fragment } from 'react'
import { Grid, Typography, withStyles, CircularProgress, Snackbar, IconButton } from "@material-ui/core";
import CloseIcon from '@material-ui/icons/Close';
// import MenuItem from './MenuItem'
import firebase from '../../firebase'
// import { Header } from '../Layouts'
import OrderCard from './OrderCard'

import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';

// import UIfx from 'uifx';
// import boopSfx from '../../sound.mp3';

// import useSound from 'use-sound';

// const soundfx = useSound(boopSfx);


// const alertSound = new UIfx(boopSfx)

// const playSound = audioFile => {
//     var play = audioFile.play(1.0);
// }

const styles = theme => ({
    paper: {
        padding: 20,
        // margin: theme.spacing(2),
        // height: 500,
        overflowY: 'auto'
    },
    root: {
        width: '100%',
        maxWidth: 360,
        backgroundColor: theme.palette.background.paper,
    },
    nested: {
        paddingLeft: theme.spacing(4),
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
})

class Orders extends Component {
    
    constructor(props) {
        super(props)
        
        this.state = {
            displayOrders: [],
            orders: [],
            loading: true,
            snackBar: false,
            paymentMode: 10,
            locationMode: 10,
            name: ""
        }
        
        this.database = firebase.database().ref().child('orders')
        
    }
    
    

    componentDidMount() {

        // const 
        
        const prevOrders = this.state.orders
        
        this.database.on('value', () => {
            this.setState({
                loading: false
            })
        })
        
        this.database.on('child_added', snap => {

            // var playback = bell.play(1)

            prevOrders.unshift(snap.val())
            this.setState({
                loading: false,
                orders: prevOrders
            })
        })
        
        this.database.on('child_removed', snap => {
            for (var i = 0; i < prevOrders.length; i++) {
                if (prevOrders[i].order_id === snap.key) {
                    prevOrders.splice(i, 1);
                    break;
                }
            }
            
            this.setState({
                orders: prevOrders
            })
            
        })
        
        this.database.on('child_changed', snap => {
            
            for (var i = 0; i < prevOrders.length; i++) {
                if (prevOrders[i].order_id === snap.key) {
                    prevOrders.splice(i, 1, snap.val());
                    break;
                }
            }
            
            this.setState({
                orders: prevOrders
            })
            
            this.forceUpdate()
            
        })
        
    }
    
    
    sendNotificationToUser = (fcm, title, body) => {
        var sendNotif = firebase.functions().httpsCallable('sendNotificationToUser');
        sendNotif({fcm, title, body}).then(function (result) {
            console.log(result)
        });
    }
    
    
    
    updateOrdersData = async (order) => {
        
        const { order_id, uid, status } = order
        
        if (status < 4) {
            this.database.child(order_id).update({ status: status + 1 })
            firebase.database().ref().child('users').child(uid).child('orders').child(order_id).update({ status: status + 1 })
        }
        
        const userSnapshot = await firebase.database().ref("users").child(uid).once("value");
        const { fcmToken } = userSnapshot.val();
        
        if (fcmToken === undefined) {
            console.log("FCM Token for user not found")
            
            if (status >= 3) {
                this.setState({
                    snackBar: true
                })
                firebase.database().ref().child('orders-archive').child(order_id).update(order)
                this.database.child(order_id).remove()
                console.log(order)
            }
            return
        }
        
        switch (status + 1) {
            case 1:
            this.sendNotificationToUser(fcmToken, "We are preparing your delicious food!", "Yum")
            console.log("send preparing food")
            break;
            case 2:
            this.sendNotificationToUser(fcmToken, "Your delicious box of food items is out for delivery", "Yum")
            console.log("send out for delivery")
            break;
            case 3:
            this.sendNotificationToUser(fcmToken, "Order delivered :)", "Enjoy your food")
            console.log("send delivered")
            break;
            case 4:
            this.setState({
                snackBar: true
            })
            firebase.database().ref().child('orders-archive').child(order_id).update(order)
            this.database.child(order_id).remove()
            console.log(order)
            break;
            default:
            break;
        }
    }
    
    
    getProcessedOrders() {

        const { paymentMode, locationMode, name } = this.state;
        console.log(paymentMode);
        
        var orders = this.state.orders
        
        
        if(paymentMode === 10){
            
            orders = this.state.orders.filter((order) => {
                return order.payment === "COD" || order.payment === "Completed"
            })
            
        }else if(paymentMode === 20){
            
            orders =  this.state.orders.filter((order) => {
                return order.payment === "COD"
            })

        }else if(paymentMode === 30){
            
            orders =  this.state.orders.filter((order) => {
                return order.payment === "Completed"
            })
        }

        if(locationMode === 10){
            
            orders = this.state.orders.filter((order) => {
                return true || order.location === "MANIPAL" || order.location === "MANGALORE"
            })
            
        }else if(locationMode === 20){
            
            orders =  this.state.orders.filter((order) => {
                return order.location === "MANIPAL"
            })
            
        }else if(locationMode === 30){
            
            orders =  this.state.orders.filter((order) => {
                return order.location === "MANGALORE"
            })
        }
        
        if(name !== ""){
            return orders.filter((order) => {
                return order.name.toLowerCase().startsWith(name.toLowerCase()) && ( order.payment === "COD" || order.payment === "Completed");
            })
        }else{
            return orders
        }
        
        
        
        
        
        
        
    }
    
    handleItemClick = (item) => {
        console.log(item)
        this.setState({
            name: item.name
        })
    }
    
    handleDeleteItemClick = (itemId) => {
        
        this.database.child(itemId).remove().then(
            console.log("successfully deleted")
            ).catch(
                console.log("error in deleting")
                )
            }
            
            handleChange = name => event => {
                this.setState({
                    [name] : event.target.value
                })
            }
            
            
            render() {
                const { name, locationMode, paymentMode, snackBar } = this.state
                const { classes } = this.props
                const orders = this.getProcessedOrders()
                console.log(orders)
                return (
                    <Fragment>
                    {this.state.loading ? < CircularProgress style={{ position: "fixed", top: "50%", left: "50%" }}></CircularProgress>
                    :
                    <div>
                    <div style={{display: 'flex', alignItems: 'flex-end'}}>
                        <FormControl variant="outlined" className={classes.formControl}>
                            <InputLabel id="demo-simple-select-outlined-label">Location</InputLabel>
                            <Select
                                labelId="demo-simple-select-outlined-label"
                                id="demo-simple-select-outlined"
                                value={locationMode}
                                onChange={this.handleChange('locationMode')}
                                label="Location" 
                            >
                                <MenuItem value={10}>All</MenuItem>
                                <MenuItem value={20}>Manipal</MenuItem>
                                <MenuItem value={30}>Mangalore</MenuItem>
                            </Select>
                        </FormControl>
                        <FormControl variant="outlined" className={classes.formControl}>
                            <InputLabel id="demo-simple-select-outlined-label">Payment Mode</InputLabel>
                            <Select
                                labelId="demo-simple-select-outlined-label"
                                id="demo-simple-select-outlined"
                                value={paymentMode}
                                onChange={this.handleChange('paymentMode')}
                                label="Payment Mode" 
                            >
                                <MenuItem value={10}>All</MenuItem>
                                <MenuItem value={20}>COD</MenuItem>
                                <MenuItem value={30}>Online</MenuItem>
                            </Select>
                        </FormControl>
                        <TextField
                            className={classes.formControl}
                            style={{ maxWidth: 300 }}   
                            margin="normal"
                            id="name"
                            label="Search by Name"
                            type="text"
                            value={name}
                            onChange={this.handleChange('name')}
                            fullWidth
                            color="secondary"
                            autoComplete="off"
                            variant="outlined"
                        />
                    </div>
                    <Grid container justify="center" spacing={4} style={{ marginTop: 6 }}>
                    {
                        orders === undefined || orders.length === 0 ? <Typography variant="h6" component="h3" style={{ position: "fixed", top: "50%", left: "45%" }}>
                        No Recent Orders
                        </Typography>
                        :
                        orders.map((order) => {
                            return (
                                <OrderCard order={order} key={order.order_id} updateHandler={this.updateOrdersData}></OrderCard>
                                )
                            })
                        }
                        </Grid>
                        </div>
                    }
                    <Snackbar
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                    open={snackBar}
                    autoHideDuration={2500}
                    onClose={() => {
                        this.setState({
                            snackBar: false
                        })
                    }}
                    message="Order Archived"
                    action={
                        <IconButton size="small" aria-label="close" color="inherit" onClick={() => {
                            this.setState({
                                snackBar: false
                            })
                        }}>
                        <CloseIcon fontSize="small" />
                        </IconButton>
                    }
                    />
                    </Fragment>
                    )
                }
            }
            
            //Object.entries
            
            export default withStyles(styles)(Orders)
            
            // < Grid item sm >
            //     <Paper className={classes.paper}>
            //         <Typography variant="h4">
            //             {this.state.name}
            //         </Typography>
            
            //         <Typography variant="button">
            //             Hello World!
            //                     </Typography>
            //     </Paper>
            //             </Grid >